
// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

// class name
// import cx from 'classnames';
// import _ from 'lodash';

import ProgressComponent from '../../../../../../common/components/C_ProgressComponent';

// must pass {withRef: true} as 4th argument to connect() to allow parent component to access
// child component's validateForm method if it is wrapped in a HOC
@connect(store => ({
  labels: get(store.labels, 'Application', {}),
}), null, null, {withRef: true})
export default class ProfileInstructions extends ProgressComponent {
  static propTypes = {
    user: PropTypes.object,
    viewState: PropTypes.object,
    tempState: PropTypes.object.isRequired,
    updateTempState: PropTypes.func.isRequired
  }

  static defaultProps = {
    user: {}
  }

  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div className='application-section-container clearfix'>
        <div className='form-heading'>
          Application Instructions
        </div>
        <div className='form-text' dangerouslySetInnerHTML={{__html:get(this.props.labels, 'instructions')}}>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_Application/r_ApplicationForm/Profile/c_Instructions/index.js